import { render, staticRenderFns } from "./CertificadosAsignarEncuesta.vue?vue&type=template&id=f8464144&scoped=true"
import script from "./CertificadosAsignarEncuesta.vue?vue&type=script&lang=js"
export * from "./CertificadosAsignarEncuesta.vue?vue&type=script&lang=js"
import style0 from "./CertificadosAsignarEncuesta.vue?vue&type=style&index=0&id=f8464144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8464144",
  null
  
)

export default component.exports